(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-capture-popup"] && !Shopify.designMode) return;
  try {
    (function(){
  var KEY_DISMISSED = 'sn_ec_dismissed';
  var KEY_SUBSCRIBED = 'sn_ec_subscribed';
  var DAYS_BEFORE_RETRY = 7;

  function alreadyHandled(){
    try{
      if (localStorage.getItem(KEY_SUBSCRIBED)) return true;
      var dismissed = localStorage.getItem(KEY_DISMISSED);
      if (dismissed && (Date.now() - Number(dismissed)) < DAYS_BEFORE_RETRY * 86400000) return true;
    }catch(e){}
    return false;
  }

  if (alreadyHandled()) return;

  var el = document.getElementById('sn-email-capture');
  if (!el) return;

  var shown = false;
  function reveal(){
    if (shown) return;
    shown = true;
    el.removeAttribute('hidden');
  }

  setTimeout(reveal, 6000);

  window.addEventListener('scroll', function onScroll(){
    var scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
    if (scrolled > 0.6) {
      reveal();
      window.removeEventListener('scroll', onScroll);
    }
  }, { passive: true });

  var form = document.getElementById('sn-ec-form');
  if (form) {
    form.addEventListener('submit', function(evt){
      evt.preventDefault();
      var submitBtn = form.querySelector('.sn-ec__submit');
      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      var data = new FormData(form);
      fetch('/contact', { method: 'POST', body: data })
        .then(function(){
          try{ localStorage.setItem(KEY_SUBSCRIBED, '1'); }catch(e){}
          document.getElementById('sn-ec-step-form').setAttribute('hidden', '');
          document.getElementById('sn-ec-step-success').removeAttribute('hidden');
        })
        .catch(function(){
          submitBtn.disabled = false;
          submitBtn.textContent = "S'inscrire";
        });
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
